import type { SectionLocale } from '../types'

export const UPDATE_PAGE_PROMPT_LOCALE: SectionLocale = [
  [
    'update_page_prompt_title',
    {
      ru: 'Доступна новая версия',
      en: 'A new version is available',
    },
  ],
  [
    'update_page_prompt_description',
    {
      ru: 'Обновите страницу, чтобы использовать последнюю версию приложения',
      en: 'Update the page to use the latest version of the application',
    },
  ],
  [
    'update_page_prompt_button',
    {
      ru: 'Обновить',
      en: 'Update',
    },
  ],
  [
    'update_page_prompt_close',
    {
      ru: 'Закрыть',
      en: 'Close',
    },
  ],
]
